import { useTranslation } from 'react-i18next';
import { type ChartData } from './chartConfigUtils';
import StandardChart from './StandardChart';

interface DailyMetalContractValueData {
    readonly date: string;
    readonly value: number;
}

interface DailyMetalContractValueChartProps {
    readonly data: readonly DailyMetalContractValueData[];
    readonly loading?: boolean;
    readonly referenceValue?: number;
    readonly currency?: 'EUR' | 'LEI';
}
function DailyMetalContractValueChart({
    data,
    loading = false,
    referenceValue,
    currency,
}: DailyMetalContractValueChartProps): JSX.Element {
    const { t } = useTranslation();
    const chartData: ChartData[] = data.map(item => ({ date: item.date, value: item.value ?? 0 }));
    const isEur = currency === 'EUR';
    return (
        <StandardChart
            data={chartData}
            loading={loading}
            referenceValue={referenceValue}
            config={{
                chartType: 'line',
                yAxisTitleKey: isEur ? 'statistics.charts.valueEur' : 'statistics.charts.valueLei',
                yAxisTitleFallback: isEur ? 'Value (EUR)' : 'Value (Lei)',
                yAxisColor: '#1890ff',
                seriesNameKey: 'statistics.charts.metalContractValue',
                seriesNameFallback: 'Metal Contract Value',
                seriesColor: '#1890ff',
                valueSuffix: isEur
                    ? (t('statistics.currencyEur', ' EUR') ?? ' EUR')
                    : (t('statistics.currencyLei', ' Lei') ?? ' Lei'),
            }}
        />
    );
}

export default DailyMetalContractValueChart;
